// extracted by mini-css-extract-plugin
export default {"hero__con":"styles_hero__con__GuoC5","scrollBtn":"styles_scrollBtn__4r4Ct","prevArrow":"styles_prevArrow__0dv2-","nextArrow":"styles_nextArrow__S+3x6"};